import React, { useState } from 'react';
import '../style/JobComponentStyles.css';

function JobComponent() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    experience: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="jobs-container">
      <div className="jobs-content">
        <div className="requirements-card">
          <h2>Job Requirements</h2>
          <ul>
            <li>Bilingual in Vietnamese and English</li>
            <li>Valid nail technician license</li>
            <li>Minimum 2 years of experience</li>
            <li>Strong attention to detail</li>
            <li>Excellent customer service skills</li>
            <li>Knowledge of sanitation practices</li>
            <li>Team player mentality</li>
          </ul>
          <div className="benefits">
            <h3>We Offer</h3>
            <ul>
              <li>Competitive commission-based pay</li>
              <li>Flexible scheduling</li>
              <li>Professional development opportunities</li>
              <li>Friendly work environment</li>
            </ul>
          </div>
        </div>

        <div className="contact-info-card">
          <h2>Contact Information</h2>

          <div className="info-item">
            <i className="fa-solid fa-phone"></i>
            <p>(469) 376-0101</p>
          </div>

          <div className="info-item">
            <i className="fa-solid fa-location-dot"></i>
            <p>102 S Old Rail Rd, Kaufman, TX 75142</p>
          </div>

          <div className="info-item">
            <i className="fa-solid fa-envelope"></i>
            <p>queennailscs@gmail.com</p>
          </div>



          <div className="info-item">
            <i className="fa-solid fa-clock"></i>
            <div>
              <p>Monday - Friday: 10 AM - 7 PM</p>
              <p>Saturday: 9 AM - 6 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>

          <div className="walk-in">
            <p>Walk-in interviews welcome during business hours</p>
          </div>
        </div>
      </div>

      <div className="application-form-card">
        <h2>Apply Now</h2>
        <form action="https://getform.io/f/bolmxdla" method="POST">
          <input type="hidden" name="form-name" value="job-application" />
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Full Name*</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email*</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="phone">Phone Number*</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="experience">Years of Experience*</label>
              <input
                type="number"
                id="experience"
                name="experience"
                min="0"
                max="50"
                value={formData.experience}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="message">Additional Information</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              placeholder=""
            />
          </div>

          <button type="submit" className="submit-button">Submit Application</button>
        </form>
      </div>
    </div>
  );
}

export default JobComponent;